import {Vue} from '~/addiesaas'
import {forOwn} from 'lodash'
import {create} from './instances'

export const beforeListeners = () => {

}

export const listeners = () => {
  const vm = new Vue()
  const headerSettings = vm.$$sliceSettings('element.header') || {}
  const components = headerSettings.components || {}

  forOwn(components, async (data, key) => {
    if (data.component && data.target) {
      await create(data, key)
    }
  })
}
